export default "__VITE_ASSET__BLqLQ89b__"